module.exports = __webpack_public_path__ + "de77a722/img/search-filter-icon.c4751a52.svg";